import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { responsive } from "@huub-web/ui/utils/responsive";
import { elevationDefinition } from "@huub-web/ui/theme/elevations";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { transition } from "@huub-web/ui/utils/transition";

const SIZE = 100;
const FOLD_TRANSPARENT_MULTIPLIER = 1.13;
const FOLD_COLOR_MULTIPLIER = 1;
const STICKER_GRADIENT_MULTIPLIER = 0.282;
const ROTATION = 10;

export const stickerWrapperStyle = recipe({
  base: {
    position: "absolute",
    zIndex: 2,
    borderRadius: "100%",
    userSelect: "none",
    transform: `rotate(${ROTATION}deg) scale(1)`,
    transition: transition("transform"),
    selectors: {
      "&:before": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: "10%",
        width: `calc(${rem(SIZE)} * 0.8)`,
        height: `calc(${rem(SIZE)} * 0.8)`,
        borderRadius: "100%",
        zIndex: -1,
        boxShadow: (elevationDefinition.l as { boxShadow: string }).boxShadow,
      },
    },
    ...responsive({
      m: {
        transform: `rotate(${ROTATION}deg) scale(1.2)`,
      },
      l: {
        transform: `rotate(${ROTATION}deg) scale(1.4)`,
      },
    }),
  },
  variants: {
    position: {
      topRight: {
        top: rem(-SIZE / 5),
        right: rem(-SIZE / 5),
      },
    },
    hasHover: {
      true: {
        cursor: "pointer",
        ":hover": {
          transform: `rotate(${ROTATION}deg) scale(1.1)`,
        },
        ...responsive({
          m: {
            ":hover": {
              transform: `rotate(${ROTATION}deg) scale(1.3)`,
            },
          },
          l: {
            ":hover": {
              transform: `rotate(${ROTATION}deg) scale(1.5)`,
            },
          },
        }),
      },
    },
  },
  defaultVariants: {
    position: "topRight",
  },
});

export const stickerTextStyle = style({
  lineHeight: "1 !important",
});

export const stickerStyle = recipe({
  base: {
    position: "relative",
    width: rem(SIZE),
    height: rem(SIZE),
    padding: theme.spacings.xs,
    borderRadius: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  variants: {
    variant: {
      gradient: {
        color: theme.colors.onGradient,
        backgroundImage: `linear-gradient(-135deg, transparent calc(${rem(SIZE)} * ${STICKER_GRADIENT_MULTIPLIER}), ${theme.colors.gradientD} calc(${rem(SIZE)} * ${STICKER_GRADIENT_MULTIPLIER} + 2%), ${theme.colors.gradientC} 70%)`,
      },
      warning: {
        backgroundImage: `linear-gradient(-135deg, transparent calc(${rem(SIZE)} * ${STICKER_GRADIENT_MULTIPLIER}), ${theme.colors.warning}} calc(${rem(SIZE)} * ${STICKER_GRADIENT_MULTIPLIER}), ${theme.colors.warning})`,
      },
    },
  },
  defaultVariants: {
    variant: "gradient",
  },
});

export const foldStyle = recipe({
  base: {
    content: "",
    display: "block",
    width: rem(SIZE),
    height: rem(SIZE),
    position: "absolute",
    zIndex: 2,
    left: `calc(${rem(SIZE)} * 0.6)`,
    bottom: `calc(${rem(SIZE)} * 0.6)`,
    borderRadius: "100%",
  },
  variants: {
    variant: {
      gradient: {
        backgroundImage: `linear-gradient(-135deg, transparent calc(${rem(SIZE)} * ${FOLD_TRANSPARENT_MULTIPLIER}),  ${theme.colors.inputBorder} calc(${rem(SIZE)} * ${FOLD_COLOR_MULTIPLIER}), ${theme.colors.inputBorder} calc(${rem(SIZE)} * ${FOLD_COLOR_MULTIPLIER}), ${theme.colors.inputBorder} 85%)`,
      },
      warning: {
        backgroundImage: `linear-gradient(-135deg, transparent calc(${rem(SIZE)} * ${FOLD_TRANSPARENT_MULTIPLIER}), #feeba7 calc(${rem(SIZE)} * ${FOLD_COLOR_MULTIPLIER}), #feeba7 calc(${rem(SIZE)} * ${FOLD_COLOR_MULTIPLIER}), #feeba7 85%)`,
      },
    },
  },
  defaultVariants: {
    variant: "gradient",
  },
});
